import React from 'react';
import { Link } from 'react-router-dom';
import { LOGO_URL, SCHOOL } from '../../lib/constants';

const PROGRAM_LINKS = [
  { label: 'Adult Karate', to: '/adult-karate' },
  { label: 'Kids Karate', to: '/kids-karate' },
  { label: 'Teen Martial Arts', to: '/teen-martial-arts' },
  { label: 'Kempo Karate', to: '/kempo-karate' },
  { label: 'Self-Defense', to: '/self-defense' },
];

const SITE_LINKS = [
  { label: 'About the School', to: '/about' },
  { label: 'Class Schedule', to: '/schedule' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Contact & Location', to: '/contact' },
];

const Footer = () => (
  <footer
    className="relative mt-10 border-t border-white/10 bg-black/60 pb-24 sm:pb-0"
    data-testid="footer"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
      {/* Brand + NAP */}
      <div className="sm:col-span-2 lg:col-span-1">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full overflow-hidden glow-red-sm">
            <img
              src={LOGO_URL}
              alt="Universal Kempo Karate"
              className="h-full w-full object-cover"
              width="40"
              height="40"
            />
          </div>
          <div className="font-display uppercase tracking-[0.18em] text-sm text-white">
            Universal Kempo Karate
          </div>
        </div>
        <p className="mt-4 text-sm text-white/65 leading-relaxed max-w-xs">
          Mind &bull; Body &bull; Spirit. Veteran &amp; family-owned karate school in Colorado
          Springs since 1980.
        </p>
      </div>

      {/* Programs */}
      <nav aria-label="Programs">
        <div className="font-display uppercase tracking-[0.18em] text-[11px] text-white/55">
          Programs
        </div>
        <ul className="mt-3 space-y-1.5 text-sm">
          {PROGRAM_LINKS.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                className="text-white/80 hover:text-white"
                data-testid={`footer-program-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      {/* Site */}
      <nav aria-label="Site navigation">
        <div className="font-display uppercase tracking-[0.18em] text-[11px] text-white/55">
          School
        </div>
        <ul className="mt-3 space-y-1.5 text-sm">
          {SITE_LINKS.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                className="text-white/80 hover:text-white"
                data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      {/* Visit */}
      <div>
        <div className="font-display uppercase tracking-[0.18em] text-[11px] text-white/55">
          Visit
        </div>
        <address className="not-italic">
          <div className="mt-3 text-sm text-white/85 font-mono-ui" data-testid="footer-address">
            {SCHOOL.address}
          </div>
          <a
            href={SCHOOL.phoneHref}
            className="mt-2 inline-block text-sm text-white hover:text-[color:var(--neon-red)] font-mono-ui min-h-[32px]"
            data-testid="footer-phone"
          >
            {SCHOOL.phone}
          </a>
        </address>
        <a
          href={SCHOOL.directionsUrl}
          target="_blank"
          rel="noreferrer noopener"
          className="mt-3 inline-block text-sm text-[color:var(--neon-red)] hover:text-[#ff5a5a] font-mono-ui uppercase tracking-[0.16em] text-[11px]"
          data-testid="footer-directions"
        >
          Get Directions &rarr;
        </a>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/55">
        <div>&copy; {new Date().getFullYear()} Universal Kempo Karate. All rights reserved.</div>
        <div className="font-mono-ui uppercase tracking-[0.18em]">Forged in Colorado Springs</div>
      </div>
    </div>
  </footer>
);

export default Footer;
